import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { formatByTheme } from '../../helpers/theme'
import { UseI18n } from '../hooks/useI18n'
import { UseTheme } from '../hooks/useTheme'

export const TextLink = ({
  id,
  value,
  labelLink,
  url,
  onClick,
  isTextDecoration,
  ...props
}) => {
  const theme = UseTheme()
  const locale = useSelector((state) => state.i18n.locale)
  const labelLinkI18n = UseI18n(labelLink)

  useEffect(() => {
    const el = document.getElementById(id)
    if (el && onClick) {
      el.addEventListener('click', onClick)
      return () => el.removeEventListener('click', onClick)
    }
  }, [locale, props])

  const getLink = () => {
    const style = `color: ${formatByTheme('#2C73E8', theme)}; ${
      isTextDecoration ? 'text-decoration: underline' : ''
    }; cursor: pointer`

    return url
      ? `<a id="${id}" href="${url}" style="${style}" target="__blank">${labelLinkI18n}</a>`
      : `<span id="${id}" style="${style}">${labelLinkI18n}</span>`
  }

  const click = (e) => {
    if (e.target.id === id) {
      onClick()
    }
  }

  return (
    <span onClick={click}>
      <Translate {...props} dangerousHTML value={value} link={getLink()} />
    </span>
  )
}

TextLink.propTypes = {
  value: PropTypes.string.isRequired,
  labelLink: PropTypes.string.isRequired,
  id: PropTypes.string,
  url: PropTypes.string,
  onClick: PropTypes.func,
  isTextDecoration: PropTypes.bool,
}

TextLink.defaultProps = {
  url: '',
  isTextDecoration: true,
}
